import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input-group" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "off-txt" }, null, -1)
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = { class: "checkbox-group" }
const _hoisted_5 = { for: "check" }
const _hoisted_6 = { class: "input-group mb-0" }
const _hoisted_7 = ["disabled"]

import { computed, ComputedRef, Ref, ref } from "vue";
import { useUserStore } from "@/stores/user";
import { checkEmailIsValid } from "@/helpers";
import MainLoader from "@/components/MainLoader.vue";
import { useAppStore } from "@/stores/app";
import PopupPrivacy from "@/components/popups/PopupPrivacy.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthEmail',
  emits: ["code-sent"],
  setup(__props, { emit: __emit }) {

const userStore = useUserStore();
const appStore = useAppStore();

const emit = __emit;
const loginLoading: Ref<boolean> = ref(false);
const compatibleConfirm: Ref<boolean> = ref(false);
const emailIsValid: ComputedRef<boolean> = computed(() =>
  checkEmailIsValid(userStore.email)
);
async function login(): Promise<void> {
  loginLoading.value = true;
  await userStore.login();
  emit("code-sent");
  loginLoading.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(login, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        type: "email",
        class: "form-control",
        placeholder: "Enter your email to continue",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(userStore).email) = $event)),
        name: "username",
        autocomplete: "username"
      }, null, 512), [
        [_vModelText, _unref(userStore).email]
      ]),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          id: "check",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compatibleConfirm).value = $event))
        }, null, 512), [
          [_vModelCheckbox, compatibleConfirm.value]
        ]),
        _createElementVNode("label", _hoisted_5, [
          _createElementVNode("span", null, [
            _createTextVNode(" I agree with "),
            _createElementVNode("span", {
              class: "button-link",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(appStore).showPopup({ component: PopupPrivacy })), ["prevent"]))
            }, " privacy policy ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: "btn btn-b btn-danger d-block",
        type: "submit",
        disabled: !compatibleConfirm.value || !emailIsValid.value || loginLoading.value
      }, [
        _createTextVNode(" Continue "),
        (loginLoading.value)
          ? (_openBlock(), _createBlock(MainLoader, { key: 0 }))
          : _createCommentVNode("", true)
      ], 8, _hoisted_7)
    ])
  ], 32))
}
}

})